import { FunctionComponent } from 'react';
import { Grid2, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const BooleanIcon: FunctionComponent<{ value: boolean }> = ({ value }) =>
    value ? (
        <CheckIcon color='success' fontSize='small' />
    ) : (
        <CloseIcon color='error' fontSize='small' />
    );

type ConfigurationGridProps = {
    configurations: {
        label: string;
        config: Record<string, boolean>;
    }[];
};

export const ConfigurationGrid: FunctionComponent<ConfigurationGridProps> = ({
    configurations,
}) => {
    const keys = [
        'keycard',
        'barcode',
        'pickup',
        'internalProduction',
        'mobileFlow',
    ];
    const keyLabels: Record<string, string> = {
        keycard: 'Keycard',
        barcode: 'Barcode',
        pickup: 'Pick-Up',
        internalProduction: 'Interne Produktion',
        mobileFlow: 'Mobile Flow',
    };

    const columnCount = configurations.length + 1;

    return (
        <Grid2 container spacing={1}>
            {/* Header row */}
            <Grid2 size={12 / columnCount} />

            {configurations.map((c) => (
                <Grid2
                    key={c.label}
                    size={12 / columnCount}
                    sx={{ textAlign: 'center' }}
                >
                    <Typography variant='body2' fontWeight={600}>
                        {c.label}
                    </Typography>
                </Grid2>
            ))}

            {/* Data rows */}
            {keys.map((key) => (
                <Grid2
                    sx={{
                        p: 2,
                        borderRadius: 1,
                        '&:hover': {
                            backgroundColor: 'action.hover',
                        },
                    }}
                    container
                    spacing={1}
                    key={key}
                    size={12}
                >
                    <Grid2 size={12 / columnCount}>
                        <Typography variant='body2'>
                            {keyLabels[key]}
                        </Typography>
                    </Grid2>
                    {configurations.map((c) => (
                        <Grid2
                            key={c.label}
                            size={12 / columnCount}
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <BooleanIcon value={!!c.config[key]} />
                        </Grid2>
                    ))}
                </Grid2>
            ))}
        </Grid2>
    );
};
